import type { TypedShoppingCart } from "@Resources/js/laravel.d.ts"

import ShoppingCartModel, { ShoppingCart } from "../Data/Models/ShoppingCartModel"

import { FakeCartItem } from "./FakeCartItem"

const ZERO_PRICE = { amount: 0, currency: "USD" }

export function emptyTypedShoppingCart(): TypedShoppingCart {
  return {
    instance: "default",
    items: [],
    quantity: 0,
    price: ZERO_PRICE,
    discount: ZERO_PRICE,
    total: ZERO_PRICE,
  }
}

export function FakeShoppingCart(overrides: Partial<TypedShoppingCart> = {}): TypedShoppingCart {
  return {
    instance: "default",
    items: [FakeCartItem()],
    quantity: 1,
    price: { amount: 999, currency: "USD" },
    discount: ZERO_PRICE,
    total: { amount: 999, currency: "USD" },
    ...overrides,
  }
}

export default function FakeShoppingCartModel(
  overrides: Partial<TypedShoppingCart> = {},
): ShoppingCart {
  return ShoppingCartModel(FakeShoppingCart(overrides))
}
